export default __webpack_public_path__ + "static/media/filters-inactive.0b2b6aa9.svg";